import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import CheckInDetails from 'components/CheckInDetails';
import {
  endDateSelector,
  startDateSelector,
  numberOfGuestsSelector
} from 'routes/DateSelection/selectors';

const mapStateToProps = createStructuredSelector({
  startDate: startDateSelector,
  endDate: endDateSelector,
  numberOfGuests: numberOfGuestsSelector
});

export default connect(mapStateToProps)(CheckInDetails);
